import { ReactNode } from 'react';

interface FeatureCardProps {
  icon: ReactNode;
  title: string;
  description: string;
}


export const FeatureCard = ({ icon, title, description }: FeatureCardProps) => {
  return (
    <div className="flex flex-col gap-4 md:gap-10 items-start px-6 md:px-0 pt-[0.63rem] pb-6 md:flex md:flex-row md:items-center">
      <div className="w-12 h-12 bg-white rounded-lg flex items-center justify-center gap-[10px] md:flex-shrink-0">
        <div className="absolute">
          {icon}
        </div>
      </div>

      <div className='text-[#FFF] flex flex-col gap-2 self-stretch'>
        <h4 className="english-body-montserrat-semibobld">{title}</h4>
        <p className="english-body-kantumruyPro-normal">{description}</p>
      </div>
    </div>
  );
};

